import * as ko from "knockout";

ko.components.register('artist-info-modal', {
	viewModel: function (params) {
		var self = this;
		self.artist = ko.observable(params.artist);
		self.id = params.id;
	},
	template:
		`<div class="modal fade" data-bind="attr: {id: id}" aria-hidden="true" aria-labelledby="artistInfoModalLabel" tabindex="-1">
			<!-- ko with: artist -->
			<div class="modal-dialog modal-lg" role="dialog">
				<div class="modal-content">
					<div class="modal-header">
							<span class="modal-title" id="artistInfoModalLabel" data-bind="text:artist_name"></span>
							<span class="user-select-all font-monospace" data-bind="text: artist_uuid"></span>
					</div>
					<div class="modal-body">
						<div class="container p-0">
							<!-- ko if: person -->
							<div class="row">
									<div class="col-3">Person:</div>
									<div class="col">
										<div data-bind="text:person()?.display_name()"></div>
										<div class="user-select-all font-monospace" data-bind="text:person()?.person_uuid()"></div>
									</div>
							</div>
							<div class="row">
									<div class="col-3">Phone #:</div>
									<div class="col" data-bind="text:person()?.phone()"></div>
							</div>
							<div class="row">
								<div class="col-3">Email:</div>
								<div class="col">
									<a data-bind="attr: {href : 'mailto:' + person()?.email_address()}, text: person()?.email_address"></a>
								</div>
							</div>
							<div class="row">
								<div class="col-3">Language:</div>
								<div class="col" data-bind="text:person()?.language"></div>
							</div>
							<!-- /ko -->
							<div class="row">
								<div class="col-3">Comment:</div>
								<div class="col" data-bind="if: person()">
									<extra-notes params="data: person()"></extra-notes>
								</div>
							</div>
							<div class="row">
								<div class="col-3">Recommendation text:</div>
								<div class="col">
									<artist-recommendation-text params="artist: $data"></artist-recommendation-text>
								</div>
							</div>
							<!-- ko if: billing_details().mangopayid -->
							<div class="row">
								<div class="col-3">Mango Pay ID:</div>
								<div class="col">
                                    <a  target="_blank"
                                        data-bind="attr:{href:'https://hub.mangopay.com/production/eu/sofaconcerts/users/' + billing_details().mangopayid() },
                                        text:billing_details()?.mangopayid()"></a>
                                </div>
							</div>
							<!-- /ko -->
							<!-- ko if: billing_details().tax_rate -->
							<div class="row">
								<div class="col-3">Tax Rate:</div>
								<div class="col" data-bind="text: billing_details().tax_rate_percent() + '% - (' + billing_details().tax_rate() +')'"></div>
							</div>
							<!-- /ko -->

							<div class="row">
								<div class="col-3">Currency:</div>
								<div class="col" data-bind="text: fee_currency()?.iso_currency_code"></div>
							</div>

                            <hr />
                            <div class="row">
								<div class="col-12">
                                Do not send gig options (matchmaking):
                                <span class="mdi mdi-18px mdi-close-box-outline"
                                        data-bind="css: {'mdi-close-box-outline': !new_no_gig_options(),
                                        'mdi-checkbox-marked': new_no_gig_options()},
                                         style: {color: new_no_gig_options() ? '#0F9388' : 'grey'},
                                       click:function(){new_no_gig_options(!new_no_gig_options());}" style="color: grey;">
                                 </span>
                                 <button class="btn btn-sm btn-outline-secondary"
                                        data-bind="visible:new_no_gig_options() != no_gig_options(),
                                                   click:function(data){set_no_gig_options(new_no_gig_options())}">
                                    Save
                                 </button>


                                </div>
                            </div>


                            <div class="row">
								<div class="col-12">
                                Allow payouts over master (direct):
                                <span class="mdi mdi-18px mdi-close-box-outline"
                                        data-bind="css: {'mdi-close-box-outline': !new_allow_payout_transfer(),
                                        'mdi-checkbox-marked': new_allow_payout_transfer()},
                                         style: {color: new_allow_payout_transfer() ? '#0F9388' : 'grey'},
                                       click:function(){new_allow_payout_transfer(!new_allow_payout_transfer());}" style="color: grey;">
                                 </span>

                                 <button class="btn btn-sm btn-outline-secondary"
                                        data-bind="visible:new_allow_payout_transfer() != allow_payout_transfer(),
                                                   click:function(data){set_payout_allow_transfer(new_allow_payout_transfer())}">
                                    Save
                                 </button>
                                 </div>
                             </div>

                            <!-- TODO START HERE WITH ARTIST ALLOW ATTACHMENTS
                            <div class="row">
								<div class="col-12">
                                Allow attachments:
                                <span class="mdi mdi-18px mdi-close-box-outline"
                                        data-bind="css: {'mdi-close-box-outline': !new_allow_attachment(),
                                        'mdi-checkbox-marked': new_allow_attachment()},
                                         style: {color: new_allow_attachment() ? '#0F9388' : 'grey'},
                                       click:function(){new_allow_attachment(!new_allow_attachment());}" style="color: grey;">
                                 </span>

                                 <button class="btn btn-sm btn-outline-secondary"
                                        data-bind="visible:new_allow_attachment() != allow_attachment(),
                                                   click:function(data){set_allow_attachment(new_allow_attachment())}">
                                    Save
                                 </button>
                                 </div>
                             </div>
                             -->


                            <div class="row mt-2">
								<div class="col-12">
                                <button class="btn btn-outline-secondary btn-sm"
                                        data-bind="disable:clearing_cache,
										click: clear_profile_amazon_cache,
										text: clearing_cache() ? 'Clearing...' :
										'Clear Profile AMAZON Cache' ">
                                Clear Profile AMAZON Cache
                                </button>
                                </div>
                             </div>


							<!-- ko if: pro_invoices().length > 0 -->
							<h5 class="mt-2">Invoices</h5>
							<ul data-bind="foreach:pro_invoices">
									<li>
											<a href="#" data-bind="attr: {href : pdf_path }" target="_blank">
													<span data-bind="text:pretty_invoice_number"></span> |
													<span data-bind="text:paid_date"></span>
											</a>
									</li>
							</ul>
								<!-- /ko -->
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-outline-primary" data-bs-dismiss="modal">Close</button>
					</div> <!-- closes modal-footer -->
				</div> <!-- closes modal-content -->
			</div> <!-- closes modal-dialog -->
			<!-- /ko -->
		</div>`
});
